module.exports = __webpack_public_path__ + "img/noskoff.jpg?cb7dc3a7d6982695d4b7159f18018667";